import { CourseFilters } from '../courses-filter/courses-filter';
import { toast } from 'react-toastify';
import appApi from '../../../api/app-api';
import { ReportCoursesType } from '../../../api/types/reports/education/courses/report-courses.type';
import { displayErrorText } from '../../../api/errors/api-error-codes';

export const getCoursesListOperation = async (
  filters: CourseFilters,
  setLoading: (loading: boolean) => any,
  setCourses: (courses: ReportCoursesType[]) => any,
) => {
  try {
    setLoading(true);
    const coursesRes = await appApi.getAllCoursesMetadata(filters);
    if (coursesRes.data.errCode) {
      toast.warn(displayErrorText(coursesRes.data.errCode));
      setLoading(false);
      return;
    }
    const data: ReportCoursesType[] = coursesRes.data.body;
    setCourses(data);

    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `getCoursesListOperation is failed with the filters: ${JSON.stringify(filters)} error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
